import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setAllCourses } from 'store/CustomReports/actions'
import { SlideHeader } from './SlideHeader'
import FilterSelectedOnly from './FilterSelectedOnly'
import { setSingleCourse } from 'store/CustomReports/actions'
import { setMultipleCourses } from 'store/CustomReports/actions'
import Search from './Search'
import { setContinueDisabled } from 'store/CustomReports/actions'
import { wait } from 'utils/helpers'

function SelectSingleOrMultipleCourses({ title = '', multiple = false }) {
  const dispatch = useDispatch()
  const {
    allCourses,
    selectedSingleCourse,
    showSelectedOnly,
    selectedMultipleCourses,
  } = useSelector((store) => store.customReports)

  const [searchValue, setSearchValue] = useState('')
  const [filteredCourses, setFilteredCourses] = useState([])

  useEffect(() => {
    dispatch(setAllCourses())
  }, [dispatch])

  useEffect(() => {
    if (allCourses && allCourses.length) {
      setFilteredCourses(
        allCourses.filter((course) =>
          course.name.toLowerCase().includes(searchValue.trim().toLowerCase())
        )
      )
    }
  }, [allCourses, searchValue])

  useEffect(() => {
    wait(() => {
      dispatch(setContinueDisabled(true, 3))

      if (selectedSingleCourse?.id || selectedMultipleCourses?.length) {
        dispatch(setContinueDisabled(false, 3))
      }
    })
  }, [dispatch, selectedSingleCourse, selectedMultipleCourses])

  console.log(
    selectedSingleCourse?.id,
    selectedMultipleCourses?.length,
    'leart47'
  )

  return (
    <>
      <SlideHeader header={title || 'Select a single course'} />
      <div className='border p-4 mx-auto single-course-container scrollbar'>
        <Search
          placeholder={'Search for a course...'}
          value={searchValue}
          setValue={setSearchValue}
        />
        <FilterSelectedOnly
          item={selectedSingleCourse}
          items={selectedMultipleCourses}
        />
        {filteredCourses && filteredCourses.length
          ? filteredCourses.map((course) => {
              const isSelected = !multiple
                ? course.course_id === selectedSingleCourse?.id
                : selectedMultipleCourses
                    ?.map((c) => c?.id)
                    ?.includes(course.course_id)

              return (
                <div
                  key={course.course_id}
                  className={`custom-control custom-checkbox mb-3 ${
                    !isSelected && showSelectedOnly && 'd-none'
                  }`}
                  style={{ zIndex: '0' }}
                >
                  <input
                    value={course.course_id}
                    className='custom-control-input'
                    id={course.course_id}
                    checked={isSelected}
                    name={course.name}
                    onChange={(e) => {
                      if (!multiple) {
                        if (+e.target.value === selectedSingleCourse?.id) {
                          dispatch(setSingleCourse(null))
                        } else {
                          dispatch(
                            setSingleCourse({
                              id: +e.target.value,
                              name: e.target.name,
                              hasQuiz: course.hasQuiz,
                              hasChecklist: course.hasChecklist,
                            })
                          )
                        }
                      } else {
                        dispatch(
                          setMultipleCourses({
                            id: course.course_id,
                            name: course.name,
                          })
                        )
                      }
                    }}
                    type='checkbox'
                  />
                  <label
                    className='custom-control-label'
                    htmlFor={course.course_id}
                  >
                    {course.name}
                  </label>
                </div>
              )
            })
          : null}
      </div>
    </>
  )
}

export default SelectSingleOrMultipleCourses
